<template>
  <posts-index ref="postsIndex" />
</template>

<script>
import { registerModule } from '@vue-storefront/core/lib/modules'
import PostsIndex from '../components/posts/Index'

async function ensureWordpressModule (store) {
  if (!store.state.wordpress) {
    const { Wordpress } = await import(
      /* webpackChunkName: "vsf-wordpress-module" */ 'src/modules/wordpress/storefront-module'
    )
    registerModule(Wordpress)
  }
}

export default {
  name: 'PostsPageIndex',
  components: { PostsIndex },
  async asyncData ({ store }) {
    await ensureWordpressModule(store)
    await store.dispatch('wordpress/loadPosts', { first: 40 })
  }
}
</script>
